import { Link } from "react-router-dom";
import { XCircle } from "lucide-react";

export function PaymentCancel() {
  return (
    <div className="flex min-h-screen items-center justify-center pt-[73px]">
      <div className="mx-4 w-full max-w-md border border-white/10 bg-surface p-8 text-center" data-testid="payment-cancel-page">
        <XCircle className="mx-auto h-16 w-16 text-slate-500" />
        <h1 className="mt-6 font-display text-3xl font-bold uppercase text-white" data-testid="payment-cancel-heading">Payment Cancelled</h1>
        <p className="mt-2 text-slate-400">Your order was not completed. Your cart items are still saved.</p>
        <Link to="/cart" className="mt-8 inline-block bg-volt px-8 py-3 font-mono text-sm font-bold uppercase text-obsidian hover:bg-white" data-testid="back-to-cart">
          Back to Cart
        </Link>
      </div>
    </div>
  );
}
